// @core/api/endpoints/workflow/publish_pipeline.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PipelineResponse,
  PublishPipelineRequest,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Publish pipeline
 * Freezes the current draft version, marks it as published, and sets the pipeline status to active. A new draft version is created for future edits.
 */
export async function PublishPipeline(
  pipeline_id: string,
  data: PublishPipelineRequest,
  options?: RequestOptions
): Promise<PipelineResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/pipelines/:pipeline_id/publish`;
  requestPath = requestPath.replace(':pipeline_id', encodeURIComponent(pipeline_id));
  const requestOptions = options;
  return client.post<PipelineResponse>(requestPath, data, requestOptions);
}
